import { DomainEntity, Id, Json } from '@homeleite/arch';
import { AnimalSummary } from '../../animal';
import { EMPTY } from '@homeleite/common-utils';
import { MilkControl } from '../../../milk-control';
import { MissingProductionReason } from './missing-production';

export class MilkedAnimal implements DomainEntity {
    constructor(
        public id = Id.gen(),
        public animal: AnimalSummary = null,
        public date: Date = null,
        public production?: number,
        public flaskNumber: number = null,
        public milkingNumber = 1,
        public position = 1,
        public lot: string = EMPTY,
        public missingProduction?: MissingProductionReason,
        public milkingId: string = null,
        public milkControlId: string = null
    ) {}

    toJson(): any {
        return {
            id: this.id,
            animal: this.animal?.toJson() ?? null,
            date: this.date?.toISOString() ?? null,
            production: this.production,
            flaskNumber: this.flaskNumber,
            milkingNumber: this.milkingNumber,
            position: this.position,
            lot: this.lot,
            missingProduction: this.missingProduction ?? null,
            milkControlId: this.milkControlId,
            milkingId: this.milkingId ?? null
        };
    }

    static fromJson(json?: any): MilkedAnimal {
        return json
            ? Json.from.simple(json, MilkedAnimal, {
                animal: json.animal ? AnimalSummary.fromJson(json.animal) : null,
                date: json.date
                    ? (typeof json.date === 'string'
                        ? new Date(json.date)
                        : json.date)
                    : null,
                missingProduction: json.missingProduction ?? null
            })
            : null;
    }
}
